<template>
  <GenericIcon
    icon="icon-[mingcute--loading-line]"
    :icon-size="iconSize"
    :data-cy="dataCy"
    class="text-tm-gray-600 animate-spin"
  />
</template>

<script setup lang="ts">
import { GenericIcon, type IconSize } from '../GenericIcon';

withDefaults(
  defineProps<{
    iconSize?: IconSize;
    dataCy?: string;
  }>(),
  {
    iconSize: 'size-16',
    dataCy: 'loadingSpinner',
  },
);
</script>
